/**
 * Wynik zapisu/publikacji per produkt (kolumny BASE / Sellasist / Allegro / Amazon / Kaufland w Gotowości) — czyste funkcje,
 * wydzielone z ReadinessPage (audyt 24.10), żeby dało się je przetestować.
 */
export function exportProblems(ev) {
  const r = ev?.response || {};
  const out = [];
  if (Array.isArray(r.problems)) r.problems.forEach(p => { const t = typeof p === 'string' ? p : p?.problem || p?.field; if (t) out.push(String(t)); });
  if (r.error) out.push(typeof r.error === 'string' ? r.error : JSON.stringify(r.error));
  if (r.problem) out.push(String(r.problem));
  if (r.update_fail_reason) out.push(`Kaufland odrzucił kartę: ${typeof r.update_fail_reason === 'string' ? r.update_fail_reason : JSON.stringify(r.update_fail_reason)}`);
  return out;
}

/** Rodzaj zdarzenia bez prefiksu kanału; Kaufland `product_data_status` → 'rejected' / 'live' / put. */
export const exportKind = (ev, cfg) => {
  if (!ev) return null;
  const k = ev.event_type.slice(cfg.prefix.length);
  if (k !== 'status') return k;
  // Kaufland: wynik sprawdzenia karty po wysyłce.
  const r = ev.response || {};
  if (r.update_fail_reason || String(r.update_status || '').toUpperCase() === 'FAILED') return 'rejected';
  if (r.product_ready === true) return 'live';
  return cfg.putKind || 'put';
};

/** Ile produktów z bieżącego biegu ma już wynik nowszy niż start (licznik po wysłanych row_index, gdy są). */
export function countExportDone({ rows, ready, statusByListing, run }) {
  if (!run) return 0;
  const base = run.rowIndexes ? (rows || []).filter(r => run.rowIndexes.has(r.row_index)) : (ready || []);
  return base.filter(r => { const l = statusByListing?.[r.id]?.last; return l && (!run.since || l.created_at > run.since); }).length;
}
